import { Classification } from "@/types/classification";
import { ClassificationCard } from "./ClassificationCard";
import { DraggableClassificationBar } from "./DraggableClassificationBar";
import React from "react";

type ClassificationBarProps = {
    classifications: Classification[];
    relevantClassifications?: Classification[];
    enabledClassifications?: Classification[];
    selectedClassificationId?: number;
    onClick?: (classification: Classification) => void;
    onReorder?: (classifications: Classification[]) => void;
    variant:
        | "buttons"
        | "buttons-single-column"
        | "inline"
        | "inline-with-names";
};

export const ClassificationBar = ({
    classifications,
    relevantClassifications,
    enabledClassifications,
    selectedClassificationId,
    onClick,
    onReorder,
    variant = "buttons",
}: ClassificationBarProps) => {
    if (onReorder) {
        return (
            <div className={`classification-bar-container`}>
                <DraggableClassificationBar
                    classifications={classifications}
                    onClick={onClick}
                    onReorder={onReorder}
                    variant={
                        variant === "buttons-single-column"
                            ? "buttons"
                            : variant
                    }
                />
            </div>
        );
    }

    return (
        <div className={`classification-bar-container`}>
            <div
                className={`classification-bar-${
                    variant === "buttons-single-column" ? "buttons" : variant
                } ${
                    variant === "buttons-single-column" ? "single-column" : ""
                }`}
            >
                {classifications.map((classification) => {
                    const state =
                        !enabledClassifications ||
                        enabledClassifications.some(
                            (enabledClassification) =>
                                enabledClassification?.id === classification?.id
                        )
                            ? "enabled"
                            : relevantClassifications?.some(
                                  (relevantClassification) =>
                                      relevantClassification?.id ===
                                      classification?.id
                              )
                            ? "relevantButDisabled"
                            : "disabled";

                    return (
                        <ClassificationCard
                            key={classification.id}
                            classification={classification}
                            onClick={onClick}
                            variant={
                                variant === "buttons-single-column"
                                    ? "buttons"
                                    : variant
                            }
                            state={state}
                            isSelected={
                                selectedClassificationId === classification.id
                            }
                        />
                    );
                })}
            </div>
        </div>
    );
};
